import { Skeleton } from "@mui/material";
import React from "react";

const CatererImage = ({ imageUrl, onImageLoad, isLoaded, children }) => (
  <div className="cater-list-item-img">
    {!isLoaded && (
      <Skeleton variant="rectangular" width="100%">
        <div style={{ paddingTop: "60%" }} />
      </Skeleton>
    )}
    <img
      onLoad={onImageLoad}
      style={{ height: !isLoaded && "0" }}
      src={imageUrl}
      className="img-fluid"
      alt="Cater"
    />
    {children}
  </div>
);

export default CatererImage;